module.exports = __webpack_public_path__ + "img/student-onboarding-3-bg.19ae26b0.svg";